export const MODAL_HEADER_MARGIN_BOTTOM = 0.75;
export const MODAL_SECTION_MARGIN = 1;
